import { useState } from "react";
import { useGenerateOPMXlsx } from "@/api/opm";
import { useMedias } from "@/api/media";
import { useCurrentUser } from "../../auth/useCurrentUser";
import { useProfileByKeycloakId } from "@/api/auth";
import { swalErrorDefault } from "@/utils/lib/swal";

export function useOpmXlsxDownload({
  id,
  clusterId,
}: {
  id: string;
  clusterId?: string;
}) {
  const [status, setStatus] = useState<string>("IDLE");
  const { mutate: downloadOPMXlsx, isPending: isDownloadingOPMXlsx } =
    useGenerateOPMXlsx();
  const { id: keycloakId } = useCurrentUser();
  const { data: currentUserProfile } = useProfileByKeycloakId({
    keycloakId,
  });
  const { data: medias } = useMedias({ entityId: id, target: "/gpon" });
  const evidencePath = medias?.find((media) => media.type === "gpon")?.path;

  function handleDownloadOPMXlsx() {
    if (!currentUserProfile?.id) {
      swalErrorDefault.fire({ text: "User belum termuat, coba lagi" });
      return;
    }
    setStatus("IN PROGRESS");
    downloadOPMXlsx(
      {
        id,
        entityId: currentUserProfile.id,
        name: `OPM-${clusterId}.xlsx`,
        evidencePath,
      },
      {
        onSuccess: (res) => {
          setStatus(res.status);
          if (res.status === "ERROR") {
            swalErrorDefault.fire({
              text: res.error ?? "Gagal generate OPM xlsx",
            });
          }
        },
        onError: () => {
          setStatus("ERROR");
          swalErrorDefault.fire();
        },
      },
    );
  }

  return { status, isDownloadingOPMXlsx, handleDownloadOPMXlsx };
}
